var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWarning(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F2F2F2",
    d: "M7 6h2v7H7z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M.667 14.003h14.666L8 1.336.667 14.003zm8-2H7.333v-1.334h1.334v1.334zm0-2.667H7.333V6.669h1.334v2.667z",
    fill: "currentColor"
  })));
}
export default SvgWarning;